import { Link } from "react-router-dom";
import ArticleCard from "@/components/feature/ArticleCard";
import { articles, siteInfo, stats } from "@/mocks/articles";

export default function Hero() {
  const featured = articles.find((item) => item.featured) ?? articles[0];

  return (
    <section className="border-b border-background-200 bg-background-100">
      <div className="mx-auto max-w-editorial px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
          <div className="fade-up flex flex-col justify-center lg:col-span-6">
            <p className="mb-5 flex items-center gap-3 text-xs font-medium tracking-[0.2em] text-primary-600">
              <span className="h-px w-8 bg-primary-500" aria-hidden="true"></span>
              第 1286 期 · 深度复盘
            </p>
            <h1 className="font-heading text-3xl font-bold leading-[1.2] text-foreground-950 md:text-[44px]">
              深挖热点背后，
              <br className="hidden sm:block" />
              那条被忽略的完整逻辑
            </h1>
            <p className="mt-5 max-w-xl text-sm leading-loose text-foreground-600 md:text-base">
              {siteInfo.intro}
            </p>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <Link
                to={`/insights/${featured.slug}`}
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                阅读本期复盘
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </Link>
              <Link
                to="/insights"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-foreground-300 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-foreground-950 hover:text-foreground-950"
              >
                浏览全部复盘
              </Link>
            </div>

            <dl className="mt-10 grid grid-cols-2 gap-x-6 gap-y-5 border-t border-background-300 pt-7 sm:grid-cols-4">
              {stats.map((item) => (
                <div key={item.label}>
                  <dt className="text-xs leading-relaxed text-foreground-500">{item.label}</dt>
                  <dd className="mt-1.5 font-heading text-2xl font-bold text-foreground-950">
                    {item.value}
                    <span className="ml-0.5 text-xs font-normal text-foreground-500">{item.unit}</span>
                  </dd>
                </div>
              ))}
            </dl>
          </div>

          <div className="fade-up fade-up-1 lg:col-span-6">
            <div className="mb-3 flex items-center justify-between">
              <span className="text-xs font-medium tracking-widest text-foreground-500">本期头条</span>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-2.5 py-1 text-xs font-medium text-accent-800">
                <i className="ri-fire-line" aria-hidden="true"></i>
                编辑力荐
              </span>
            </div>
            <ArticleCard article={featured} variant="large" />
          </div>
        </div>
      </div>
    </section>
  );
}